import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.CYAN,
    codeProp: 'pcdgUserCode',
    detailIdProp: 'pcdgId',
    detailUrl: '/DmPcdgDetail',
    listUrl: '/DmPcdgList',
    mapProp: 'pcdgMap',
    name: '标准字段组',
    textProp: 'pcdgName',
    type: 'CDG',
}
